let apiPath = "";

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    apiPath = "https://crisps-snacks-recommendations-tool-co-uk.wspuat.com";
} else {
    apiPath = "";
}

export default apiPath;